
export const GET_PAGE = "GET_PAGE";
export const GET_PAGE_FAILURE = "GET_PAGE_FAILURE";
export const GET_PAGE_SUCCESS = "GET_PAGE_SUCCESS";